import { Link } from 'react-router-dom';
import { BookOpen, Clock, Wrench, AlertTriangle, Euro, Layers, ShieldCheck } from 'lucide-react';
import { AnimatedSection, AnimatedItem, AnimatedCard } from '@/components/animations';
import { motion } from 'framer-motion';
import { staggerContainer } from '@/components/animations';

const guideLinks = [
  {
    to: '/vida-util-elevador',
    icon: Clock,
    title: 'Vida útil do elevador',
    desc: 'Quanto dura um elevador e sinais de degradação',
  },
  {
    to: '/quando-modernizar-elevador',
    icon: Wrench,
    title: 'Quando modernizar',
    desc: 'Critérios técnicos para a decisão de modernização',
  },
  {
    to: '/tipos-elevadores',
    icon: Layers,
    title: 'Tipos de elevadores',
    desc: 'Tração, hidráulico, residencial e plataformas',
  },
  {
    to: '/elevador-preso-o-que-fazer',
    icon: AlertTriangle,
    title: 'Elevador preso: o que fazer',
    desc: 'Procedimentos de segurança e prevenção',
  },
  {
    to: '/custo-modernizacao-elevador',
    icon: Euro,
    title: 'Custo de modernização',
    desc: 'Valores de referência e fatores de custo em 2026',
  },
  {
    to: '/manutencao-elevadores',
    icon: ShieldCheck,
    title: 'Manutenção de elevadores',
    desc: 'O que deve ser feito e quem é responsável pelo contrato',
  },
];

export function TechnicalGuidesLinks() {
  return (
    <section className="py-12 md:py-16 border-t border-border">
      <div className="container">
        <AnimatedSection className="max-w-5xl mx-auto" stagger>
          <AnimatedItem className="text-center mb-8">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-primary/10 text-primary text-xs font-medium mb-4">
              <BookOpen className="w-3.5 h-3.5" />
              Novo
            </div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground mb-2">
              Guias técnicos sobre elevadores
            </h2>
            <p className="text-muted-foreground text-sm max-w-xl mx-auto">
              Conteúdo técnico independente para apoiar decisões sobre modernização, segurança e custos.
            </p>
          </AnimatedItem>

          <motion.div
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3"
            variants={staggerContainer}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: '-50px' }}
          >
            {guideLinks.map((link) => (
              <AnimatedItem key={link.to}>
                <Link to={link.to}>
                  <AnimatedCard className="p-4 rounded-xl bg-card border border-border hover:border-primary/40 transition-colors h-full">
                    <div className="flex items-start gap-3">
                      <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
                        <link.icon className="w-4 h-4 text-primary" />
                      </div>
                      <div>
                        <h3 className="font-semibold text-foreground text-sm mb-0.5">{link.title}</h3>
                        <p className="text-xs text-muted-foreground">{link.desc}</p>
                      </div>
                    </div>
                  </AnimatedCard>
                </Link>
              </AnimatedItem>
            ))}
          </motion.div>
        </AnimatedSection>
      </div>
    </section>
  );
}
